module.exports = __webpack_public_path__ + "img/score.6140d00c.jpeg";